export default "__VITE_ASSET__DXCRFRPy__"